import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { MirrorService } from 'services/MirrorService';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { ImagedPopup } from 'components/UI/ImagedPopup';

import thumbnailImg from './images/thumbnail.jpg';
import thumbnailMePlusYouImg from './images/thumbnail_meplusyou.jpg';

import css from './basePaymentFailPopup.module.sass';

interface Props {
  buttonText: string;
  onClose?: () => void;
  onContinue?: () => void;
  onMount?: () => void;
}

export const BasePaymentFailPopup: React.FC<Props> = ({
  buttonText,
  onClose,
  onContinue,
  onMount,
  children,
}) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    onMount && onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ImagedPopup
      image={
        MirrorService.isMePlusYouOrLocalsjoy
          ? thumbnailMePlusYouImg
          : thumbnailImg
      }
      icon={<InfoIcon fill="#fff" />}
      onClose={onClose}
    >
      <p
        className={classNames(css.title, {
          [css.titleThemeMePlusYou]: MirrorService.isMePlusYouOrLocalsjoy,
        })}
      >
        {t('paymentUnsuccessful')}
      </p>
      {children}
      <BaseButton
        type={
          MirrorService.isMePlusYouOrLocalsjoy
            ? ButtonTypes.Primary
            : ButtonTypes.Accent
        }
        className={css.button}
        onClick={onContinue}
      >
        {buttonText}
      </BaseButton>
    </ImagedPopup>
  );
};
